import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from 'react';

const CustomTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  '& .MuiTooltip-tooltip': {
    color: '#2b2b2b',
    backgroundColor: '#FFF3C9',
    padding: '15px 21px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #DBD5CE',
  },
  '& .MuiTooltip-arrow': {
    color: '#FFF3C9',
  },
});

const ToolTipCustomV2 = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  '& .MuiTooltip-tooltip': {
    width: '312px',
    height: '132px',
    padding: '12px 16px',
    fontFamily: 'Titilium Regular',
    fontSize: '15px',
    color: '#36393B',
    backgroundColor: '#FFF3C9',
    border: '1px solid #EBDFB6',
    boxShadow: '-2px 2px 11px 1px rgba(0,0,0,0.1)',
    marginBottom: '35px',
  },
  '& .MuiTooltip-arrow': {
    '&:before': {
      border: '1px solid #EBDFB6',
    },
    color: '#FFF3C9',
  },
});


const TooltipCustom = ({ children, title, placement, variant, arrow }) => {
  function renderChildren() {
    return <div className="tooltip">{children}</div>;
  }

  return (
    <>
      {variant === 'secondary' && (
        <CustomTooltip title={title} placement={placement}>
          {renderChildren()}
        </CustomTooltip>
      )}
      {variant === 'custom' && (
        <ToolTipCustomV2 title={title} placement={placement} arrow={arrow}>
          {renderChildren()}
        </ToolTipCustomV2>
      )}
      {variant === 'default' && (
        <Tooltip title={title} placement={placement}>
          {renderChildren()}
        </Tooltip>
      )}
      {variant === 'info' && (
        <Tooltip title={title} placement={placement} arrow={arrow} PopperProps={{ className: 'tooltip-info-popper' }}>
          {renderChildren()}
        </Tooltip>
      )}
    </>
  );
};

export default TooltipCustom;
